import IProduct from 'models/product';
import DateField from 'components/inputfields/DateField';
import ThreeWaySwitch from 'components/inputfields/ThreeWaySwitch';

interface IOrderableUnitProps {
  readOnly?: boolean;
  state: IProduct;
  approve?: boolean;
  setState: (state: IProduct) => void;
}

const PurchaseRelatedFields = ({ readOnly, approve, state, setState }: IOrderableUnitProps) => {
  const handleChange = (name: string, dateTime: number | null) => {
    setState({ ...state, [name]: dateTime });
  };

  return (
    <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
      <div style={{ flex: 1 }}>
        <DateField
          readOnly={readOnly}
          name="basicDataAvailabilityDateFrom"
          value={state.basicDataAvailabilityDateFrom}
          placeholder="ÅÅÅÅ-MM-DD, t.ex. 2020-02-04"
          labelOptions={{ heading: 'Lanseringsdag mot konsument för nyheter' }}
          onChange={handleChange}
        />
        <DateField
          readOnly={readOnly}
          name="articleFirstOrderDate"
          value={state.articleFirstOrderDate}
          placeholder="ÅÅÅÅ-MM-DD, t.ex. 2020-02-01"
          labelOptions={{
            heading: 'Första beställningsdag för nyheter',
            text: 'Ange datumet då produkten blir beställningsbar.',
          }}
          onChange={handleChange}
          helpText='Lämna fältet tomt om produkten redan är beställningsbar'
        />
      </div>
      {/* TODO: Temporarily disabled packagingLogistics approval because it groups scattered fields across different sections (dates, supplier article, logistics) under a single review key, causing synchronized UI changes that confuse superusers. */}
      {/* {approve && state?.approve?.find(x => x.field === 'packagingLogistics') && (
        <ThreeWaySwitch
          readOnly={readOnly}
          state={state}
          setState={setState}
          name={"packagingLogistics" as keyof IProduct}
        />
      )} */}
      {/* Hidden per Apotea request — uncomment to restore. Persisted value still round-trips via utils.js. */}
      {/* <DateField
        name="articleFirstDelivery"
        value={state.articleFirstDelivery}
        placeholder="Ex. 2020-02-03"
        labelOptions={{ heading: 'Första leveransdag för nyheter' }}
        onChange={handleChange}
      /> */}
    </div>
  );
};

export default PurchaseRelatedFields;
